export const carpetasIniciales = [
  'Información TI',
  'Información CA',
  'Información General'
];

export const carpetasInicialesBetter = [
  {
    carpeta: 'Comunicación NOM-035',
    subcarpeta: []
  },
  {
    carpeta: 'Listado de colaboradores NOM-035',
    subcarpeta: []
  },
  {
    carpeta: 'PDF de resultados NOM-035',
    subcarpeta: []
  },
];
export const carpetasInicialesAll = [
  {
    carpeta: 'Row Data',
    visible: true,
    subcarpeta: []
  }
]
export const carpetasInicialesMX = [
  {
    carpeta: 'Campaña de Comunicación 2020',
    visible: true,
    subcarpeta: []
  },
  {
    carpeta: 'Culture Audit',
    visible: true,
    subcarpeta: []
  },
  {
    carpeta: 'Guía de certificación',
    visible: true,
    subcarpeta: []
  },
  {
    carpeta: 'Listado de colaboradores',
    visible: true,
    subcarpeta: []
  },
  {
    carpeta: 'Plantillas',
    visible: false,
    subcarpeta: [
      {
        carpeta: 'Templates con TI',
        visible: true,
        subcarpeta: []
      },
      {
        carpeta: 'Templates Página',
        visible: true,
        subcarpeta: [
          {
            carpeta: 'Certificar',
            visible: true,
            subcarpeta: []
          },
          {
            carpeta: 'Focus Area',
            visible: true,
            subcarpeta: []
          },
          {
            carpeta: 'Medir',
            visible: true,
            subcarpeta: []
          },
          {
            carpeta: 'Pulsecheck',
            visible: true,
            subcarpeta: []
          },
        ]
      }
    ]
  },
];
export const carpetasInicialesPriv = [
  {
    carpeta: 'Raw Data',
    visible: true,
    subcarpeta: []
  }
]
export const archivosInicialesMX = [
  {
    carpeta: "Campaña de Comunicación 2020",
    archivos: [
      {nombre: 'Comunicados Editables GPTW_v1.pptx', tamanio: 6445287},
      {nombre: 'Floor sticker.jpg', tamanio: 2139158},
      {nombre: 'Poster tabloide-01.jpg', tamanio: 1636470},
      {nombre: 'Poster tabloide-02.jpg', tamanio: 2149219},
      {nombre: 'Poster tabloide-03.jpg', tamanio: 2111929},
      {nombre: 'Poster-01.jpg', tamanio: 7776785},
      {nombre: 'Propuesta_conceptual_Comunicación_Interna_Junio_2018.pdf', tamanio: 1459650},
      {nombre: 'wallpaper-01.jpg', tamanio: 3046475},
      {nombre: 'wallpaper-02.jpg', tamanio: 2979503},
      {nombre: 'wallpaper-03.jpg', tamanio: 3976501},
    ]
  },
  {
    carpeta: "Culture Audit",
    archivos: [
      // {nombre: 'LayOut CA.xlsx', tamanio: 55731},
      // {nombre: 'Esqueleto CA 2020.xls', tamanio: 344064},
      // {nombre: 'CA_CR_2021.xlsx', tamanio: 39462},
      // {nombre: 'CA_MX_2021.xlsx', tamanio: 39582},
      // {nombre: 'CA_PAN_2021.xlsx', tamanio: 39318},
      {nombre: 'Lay out completo_2021.xlsx', tamanio: 753564},
      {nombre: 'COMO HACER EL MEJOR CULTURE AUDIT.pdf', tamanio: 631658},
    ]
  },
  {
    carpeta: "Guía de certificación",
    archivos: [
      {nombre: 'Guía_de_certificación_2020_v3.pdf', tamanio: 1902346},
    ]
  },
  {
    carpeta: "Listado de colaboradores",
    archivos: [
      {nombre: 'CollaboratorsListTemplate_es.xlsm', tamanio: 563176},
      {nombre: 'Guia_homologación_cargos.xlsx', tamanio: 10834},
      {nombre: 'Listado_de_colaboradores_excel.xlsx', tamanio: 13037},
    ]
  },
  {
    carpeta: "Plantillas",
    subcarpeta: [
      {
        carpeta: "Templates con TI",
        archivos: [
          {nombre: 'Mexico_Estandar_TI_Certificar_Mexico_English_GPTW_ForAll_2020.xlsx', tamanio: 38735},
          {nombre: 'Mexico_Estandar_TI_Certificar_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 53154},
          {nombre: 'Mexico_Estandar_TI_Certificar_US_English_GPTW_ForAll_2020.xlsx', tamanio: 38354},
          {nombre: 'Mexico_Estandar_TI_Certificar_US_Español_GPTW_ForAll_2020.xlsx', tamanio: 52769},
        ]
      },
      {
        carpeta: "Templates Página",
        subcarpeta: [
          {
            carpeta: "Certificar",
            archivos: [
              {nombre: 'Mexico_Estandar_Certificar_Mexico_English_GPTW_ForAll_2020.xlsx', tamanio: 32549},
              {nombre: 'Mexico_Estandar_Certificar_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 31907},
              {nombre: 'Mexico_Estandar_Certificar_US_English_GPTW_ForAll_2020.xlsx', tamanio: 32571},
              {nombre: 'Mexico_Estandar_Certificar_US_Español_GPTW_ForAll_2020.xlsx', tamanio: 31752},
            ]
          },
          {
            carpeta: "Focus Area",
            archivos: [
              {nombre: 'Focus_Area_Alineacion_Estrategica_CH_GPTWMX2020.xlsx', tamanio: 12333},
              {nombre: 'Focus_Area_Cultura_Organizacional_Palabra_GPTWMX2020.xlsx', tamanio: 11535},
              {nombre: 'Focus_Area_Disposición_Cambio_GPTWMX2020.xlsx', tamanio: 19556},
              {nombre: 'Focus_Area_Diversidad_Inclusión_GPTWMX2020.xlsx', tamanio: 13377},
              {nombre: 'Focus_Area_Drivers_Millenials_GPTWMX2020.xlsx', tamanio: 15634},
              {nombre: 'Focus_Area_E_Agilidad_GPTWMX2020.xlsx', tamanio: 12636},
              {nombre: 'Focus_Area_E_Autenticidad_GPTWMX2020.xlsx', tamanio: 12070},
              {nombre: 'Focus_Area_E_Efectividad_estrategica_GPTWMX2020.xlsx', tamanio: 12257},
              {nombre: 'Focus_Area_E_Enfoque_Cliente_GPTWMX2020.xlsx', tamanio: 11996},
              {nombre: 'Focus_Area_E_Engagement_GPTWMX2020.xlsx', tamanio: 12749},
              {nombre: 'Focus_Area_E_Innovacion_GPTWMX2020.xlsx', tamanio: 12675},
              {nombre: 'Focus_Area_E_Mentalidad_Proactiva_GPTWMX2020.xlsx', tamanio: 12062},
              {nombre: 'Focus_Area_E_Pulsecheck_GPTWMX2020.xlsx', tamanio: 14678},
              {nombre: 'Focus_Area_E_Resistencia_Cambio_GPTWMX2020.xlsx', tamanio: 12740},
              {nombre: 'Focus_Area_E_Trabajo_Equipo_GPTWMX2020.xlsx', tamanio: 12398},
              {nombre: 'Focus_Area_Lider_Informal_GPTWMX2020.xlsx', tamanio: 11448},
              {nombre: 'Focus_Area_Tres_Compromisos_GPTWMX2020.xlsx', tamanio: 14059},
            ]
          },
          {
            carpeta: "Medir",
            archivos: [
              {nombre: 'Mexico_Estandar_Medir_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 31907},
              {nombre: 'Mexico_Medir_Compañerismo_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 12411},
              {nombre: 'Mexico_Medir_Credibilidad_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 13392},
              {nombre: 'Mexico_Medir_Imparcialidad_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 12996},
              {nombre: 'Mexico_Medir_Orgullo_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 12940},
              {nombre: 'Mexico_Medir_Respeto_México_Español_GPTW_ForAll_2020.xlsx', tamanio: 13421},
            ]
          },
          {
            carpeta: "Pulsecheck",
            archivos: [
              {nombre: 'Pulse _Check_GPTWMX2020.xlsx', tamanio: 26482},
            ]
          },
        ]
      }
    ]
  }
];


export const archivosInicialesBetter = [
  {
    carpeta: "Comunicación NOM-035",
    archivos: [
      {nombre: 'Poster_NOM035_Horizontal_01.jpeg', tamanio: 222394},
      {nombre: 'Poster_NOM035_Horizontal_02.jpeg', tamanio: 217513},
      {nombre: 'Poster_NOM035_Vertical_01.jpeg', tamanio: 235953},
      {nombre: 'Poster_NOM035_Vertical_02.jpeg', tamanio: 236246}
    ]
  },
  {
    carpeta: "Listado de colaboradores NOM-035",
    archivos: [
      {nombre: 'CollaboratorsDBTemplate_NORM035STP_es.xlsx', tamanio: 20480},
      //17,772
    ]
  },
  {
    carpeta: 'PDF de resultados NOM-035',
    archivos: [
      {nombre: 'Guía de Referencia I.pdf', tamanio: 36864},
      {nombre: 'Guía de Referencía II.pdf', tamanio: 122880},
      {nombre: 'Guía de Referencia III.pdf', tamanio: 122880 }
    ]
  }
];

export const archivosInicialesPublic = [
  {
    carpeta: 'Raw Data',
    archivos: [
      {nombre: 'Example.xlsx', tamanio: 122880}
    ]
  }
];
